var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LibraryCategoryCard',[_c('CategoryAuthorInfo',_vm._b({},'CategoryAuthorInfo',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }